import { TraitSale } from "types";
import * as traitSalesApi from "api/traitSalesApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchTraitSales = (data: traitSalesApi.FetchTraitSalesData) =>
  useFetchPromise<TraitSale[], traitSalesApi.FetchTraitSalesData>(
    traitSalesApi.fetchTraitSales,
    data
  );

export default useFetchTraitSales;
